<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: getCSSVar("--xg-blue")
  }
);

const cubeStyle = { backgroundColor: props.color };
</script>

<template>
  <div class="loading-5">
    <div
      class="cube1"
      :style="cubeStyle"
    ></div>
    <div
      class="cube2"
      :style="cubeStyle"
    ></div>
  </div>
</template>

<style scoped>
.loading-5 {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}

.cube1,
.cube2 {
  width: 40%;
  aspect-ratio: 1 / 1;
  display: inline-block;
  position: absolute;
  top: 10%;
  left: 10%;
  transform: translate(-10%, -10%);
  animation: cubemove 1.8s infinite ease-in-out;
  transform-origin: center;
}

.cube2 {
  animation-delay: -0.9s;
}

@keyframes cubemove {
  25% {
    transform: translateX(42px) rotate(-90deg) scale(0.5);
  }
  50% {
    transform: translateX(42px) translateY(42px) rotate(-179deg);
  }
  50.1% {
    transform: translateX(42px) translateY(42px) rotate(-180deg);
  }
  75% {
    transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>
